import { POSITIONS_LABELS } from './constants';

import { PlayerPositionAbbr } from '@/types';

const { ARQ, DEF, VOL, DEL } = POSITIONS_LABELS.abbreviation;
export const fieldPlayersF5: PlayerPositionAbbr[] = [DEF, VOL, DEL];
export const goalKepperF5: PlayerPositionAbbr[] = [ARQ];
